// src/components/ErrorFallback.tsx
import { FallbackProps } from 'react-error-boundary';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  // You can also log the error to a service like Sentry or LogRocket here
  console.error(error);

  return (
   <div
      className="flex flex-col items-center justify-center min-h-screen bg-gray-100"
      role="alert"
    >
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800">
            Something went wrong
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            We're sorry, but an unexpected error has occurred.
          </p>
        </div>
        <div className="p-4 bg-red-100 border border-red-400 rounded-md">
          <pre className="text-sm text-red-700 whitespace-pre-wrap">
            {error.message}
          </pre>
        </div>
        <button
          onClick={resetErrorBoundary}
          className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Try again
        </button>
      </div>
    </div>
  );
}